import React from "react";
import { Spinner } from "react-bootstrap";

export default function AddressSearchStatus({ loading, ready = true, status, count = 0 }) {
  const busy = loading || !ready;
  return (
    <div role="status" aria-live="polite" aria-atomic="true" style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, margin: "6px 0" }}>
      {busy && <Spinner animation="border" size="sm" aria-hidden="true" />}
      <span>{!ready ? "Loading address search…" : loading ? "Searching for addresses…" : status === "ZERO_RESULTS" ? "No matches. Try a road, area or landmark." : status && status !== "OK" ? "Address search is unavailable. Please try again." : count ? "Choose a suggestion below to confirm the address." : "Start typing an address or landmark, then choose a suggestion."}</span>
    </div>
  );
}
